webModule.controller('welcomeController',
    ['$scope','$rootScope', '$location', '$timeout', 'welcomeEvents', 'growl', 'routes', 'providerFeatureEvents', 'erateSessionVarsService', 'quoteIntegrationService', 'quoteIntegrationConstants',
        function ($scope, $rootScope, $location, $timeout, welcomeEvents, growl, routes, providerFeatureEvents,  erateSessionVarsService, quoteIntegrationService, quoteIntegrationConstants) {

            $scope.searchQuery = '';
            $scope.mastheadHideSearch = true;

            $scope.search = function () {
                $location.path(routes.search);
                //broadcasting the change to the search controller, but waiting until the controller is loaded (listener needs to be registered before the broadcast is done)
                $timeout(function () {
                    //broadcast will available to every listener
                    $rootScope.$broadcast(welcomeEvents.welcomeFindTransaction, $scope.searchQuery);
                }, 500);
            };
        }]);